import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-utm',
  templateUrl: './utm.component.html',
  styleUrls: ['./utm.component.scss']
})
export class UtmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
